import { render, staticRenderFns } from "./search-light-source.modal.vue?vue&type=template&id=0c669840&"
import script from "./search-light-source.modal.vue?vue&type=script&lang=ts&"
export * from "./search-light-source.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports